import React from 'react';
import ReactDOM from 'react-dom/client';
import App from '../src/main-component/App/App';
import reportWebVitals from './reportWebVitals';

import { ParallaxProvider } from 'react-scroll-parallax';
import { BrowserRouter } from "react-router-dom";   // ✅ ADD
import { HelmetProvider } from "react-helmet-async";

import 'bootstrap/dist/css/bootstrap.min.css';
import './css/themify-icons.css';
import './css/animate.css';
import './css/flaticon.css';
import './sass/style.scss';

import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./store/index";
import { Provider } from "react-redux";

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <HelmetProvider>
        <BrowserRouter>        {/* ✅ THIS FIXES EVERYTHING */}
          <ParallaxProvider>
            <App />
          </ParallaxProvider>
        </BrowserRouter>
      </HelmetProvider>
    </PersistGate>
  </Provider>
);

reportWebVitals();
